<div class="gridheight mat-elevation-z8 viewport">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
      <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row">
            <div>
              <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="onOpen(row, 'Edit')">
                <mat-icon>edit</mat-icon>
              </button>
              @if(controlPermissions.deleteMetal){
                <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDelete(row.id, row.m_LabName)" style="color: red;">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>

      <ng-container matColumnDef="m_LabName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Lab Name </th>
        <td mat-cell *matCellDef="let element"> {{element.m_LabName}} </td>
      </ng-container>

      <ng-container matColumnDef="m_LabreportID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Lab Report ID </th>
        <td mat-cell *matCellDef="let element"> {{ element.m_LabreportID }} </td>
      </ng-container>

      <ng-container matColumnDef="m_DateSampled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sample Date </th>
        <td mat-cell *matCellDef="let element"> {{ formatDate(element.m_DateSampled) }} </td>
      </ng-container>
      <ng-container matColumnDef="m_DateTested">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Test Date </th>
        <td mat-cell *matCellDef="let element"> {{ formatDate(element.m_DateTested) }} </td>
      </ng-container>
      <ng-container matColumnDef="testingTypeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Testing Type </th>
        <td mat-cell *matCellDef="let element"> {{element.testingTypeName}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let element" [ngClass]="getStatusCellClass(element)"> {{element.status}} </td>
      </ng-container>
      <ng-container matColumnDef="ts">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TS </th>
        <td mat-cell *matCellDef="let element"> {{element.ts}} </td>
      </ng-container>
      <ng-container matColumnDef="tS_mg_L">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TS (mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.tS_mg_L}} </td>
      </ng-container>
      <ng-container matColumnDef="as_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> As Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.as_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="cd_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cd Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.cd_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="cr_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cr Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.cr_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="co_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Co Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.co_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="cu_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cu Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.cu_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="pb_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Pb Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.pb_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="hg_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Hg Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.hg_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="mo_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Mo Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.mo_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="ni_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ni Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.ni_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="se_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Se Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.se_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="zn_Dry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Zn Dry </th>
        <td mat-cell *matCellDef="let element"> {{element.zn_Dry}} </td>
      </ng-container>
      <ng-container matColumnDef="as_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> As Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.as_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="cd_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cd Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.cd_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="cr_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cr Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.cr_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="co_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Co Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.co_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="cu_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cu Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.cu_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="pb_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Pb Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.pb_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="hg_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Hg Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.hg_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="mo_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Mo Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.mo_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="ni_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ni Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.ni_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="se_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Se Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.se_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="zn_Wet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Zn Wet </th>
        <td mat-cell *matCellDef="let element"> {{element.zn_Wet}} </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Notes </th>
        <td mat-cell *matCellDef="let element"> {{element.notes}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length"
          style="color: red;text-align: center;font-weight: 500;">
          No Metals data matching the filter.
        </td>
      </tr>
      <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length"
            style="color: red;text-align: center;font-weight: 500;">
            No data matching the filter.
          </td>
        </tr> -->
    </table>
    <!-- <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
  </mat-card-content>
</mat-card> -->
</div>

